export const INVOICES_STORE = 'invoices/store';
export const INVOICES_UPDATE = 'invoices/update';
export const INVOICES_DESTROY = 'invoices/destroy';

export default {
  INVOICES_STORE,
  INVOICES_UPDATE,
  INVOICES_DESTROY,
};
